import React, { useState, useContext } from "react";
import ReusableModal from "../ManageSettings/ReusableModal";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import { useToastHandler } from "../../../common/ToastHandler";
import PaginatedSearchSelect from "../../../common/ReusableComponent/PaginatedSearchSelect/PaginatedSearchSelect";
import ChipList from "../../../common/ReusableComponent/ChipList";
import { ToastContainer } from "react-toastify";
import { RegularButton } from "../../../common/ReusableComponent/CustomButton";

const AddExpenseTypeModal = ({ show, handleClose, onExpenseTypeAdded }) => {
  const { user } = useContext(AuthContext);
  const storeId = user.store;
  const { Post, GetPaginatedData } = useApi();
  const { handleToast } = useToastHandler();
  const [selectedExpenseList, setSelectedExpenseList] = useState([]);

  const handleExpenseSelect = (expense) => {
    if (!expense) return;
    const exists = selectedExpenseList.some(
      (item) => item.id === expense.id
    );
    if (!exists) {
      setSelectedExpenseList((prev) => [...prev, expense]);
    }
  };

  const handleRemove = (item) => {
    setSelectedExpenseList((prev) =>
      prev.filter((exp) => exp.id !== item.id)
    );
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (selectedExpenseList.length === 0) {
      handleToast({
        type: "WARNING",
        message: "Please select expense type",
      });
      return;
    }
    try {
      const payload = selectedExpenseList.map((item) => ({
        store: storeId,
        all_department: null,
        all_expense_type: item.id,
      }));
      const response = await Post("vendorDepartmentServiceData", payload);

      if (response.data.total_skipped > 0) {
        handleToast({
          type: "WARNING",
          message: response.data.skipped[0].message,
        });
      } else if (response.data.total_created > 0) {
        handleToast({
          type: "SUCCESS",
          message: "Expense type added successfully!",
        });
        onExpenseTypeAdded?.(response.data);
      }

      setSelectedExpenseList([]);
      handleClose();

    } catch (error) {
      console.error(error);
      const errorData = error.response?.data;
      let errorMessage = "Error saving expense type";

      if (errorData?.total_skipped > 0) {
        errorMessage = errorData.skipped[0].message;
      } else if (errorData?.message) {
        errorMessage = errorData.message;
      }

      handleToast({
        type: "ERROR",
        message: errorMessage,
      });
    }
  };
  return (
    <>
      <ToastContainer />
      <ReusableModal
        show={show}
        handleClose={handleClose}
        title="Add Expense Type"
        width="760px"
        height="300px"
      >
        <form onSubmit={handleSave}>
          { }
          <div className="form-group product-field mt-4">
            <PaginatedSearchSelect
              api="allExpenseTypeData"
              GetPaginatedData={GetPaginatedData}
              getOptionLabel={(opt) => opt.title || ""}
              onSelect={handleExpenseSelect}
              placeholder="Select Expense Type"
              pageSize={10}
            />
          </div>
          { }
          <ChipList
            items={selectedExpenseList}
            onRemove={handleRemove}
            displayField="title"
            keyField="id"
          />
          { }
          <div style={{ textAlign: "right", marginTop: "15px" }}>
            <RegularButton
              id="expensetypesubmit"
              text="Save"
              onClick={handleSave}
              type="submit"
            />
          </div>
        </form>
      </ReusableModal>
    </>
  );
};

export default AddExpenseTypeModal;